import {css} from 'styled-components';

import {ReactNode} from 'react';

import {Nullish} from 'shared/web';

import {useResponsivePropValue} from '../../../hooks/useResponsivePropValue';
import {Integer} from '../../../types/Integer';
import {ValueByDevice} from '../../../types/ValueByDevice';

export interface GridItemProps {
  span?: Integer | ValueByDevice<Integer> | Nullish;
  rowSpan?: Integer | ValueByDevice<Integer> | Nullish;
  columnStart?: number | ValueByDevice<number | undefined> | Nullish;
  rowStart?: number | ValueByDevice<number | undefined> | Nullish;
  children?: ReactNode;
}

export function GridItem(props: GridItemProps) {
  const span = useResponsivePropValue(props.span);
  const rowSpan = useResponsivePropValue(props.rowSpan);
  const columnStart = useResponsivePropValue(props.columnStart);
  const rowStart = useResponsivePropValue(props.rowStart);

  // Prevent content from expanding grid items
  // https://stackoverflow.com/questions/43311943/prevent-content-from-expanding-grid-items
  return (
    <div
      css={css`
        grid-column-start: ${columnStart ?? 'auto'};
        grid-column-end: ${span ? `span ${span}` : 'initial'};
        grid-row-start: ${rowStart ?? 'auto'};
        grid-row-end: ${rowSpan ? `span ${rowSpan}` : 'initial'};
        min-width: 0;
      `}
    >
      {props.children}
    </div>
  );
}
